var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFiles = function SvgFiles(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6V6.6H4.8C3.80589 6.6 3 7.40589 3 8.4V19.2C3 20.1941 3.80589 21 4.8 21H19.2C20.1941 21 21 20.1941 21 19.2V8.4C21 7.40589 20.1941 6.6 19.2 6.6H15V6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6ZM12 4.2C11.0059 4.2 10.2 5.00589 10.2 6V6.6H13.8V6C13.8 5.00589 12.9941 4.2 12 4.2ZM3.79307 11.8409C8.42799 16.1193 15.5721 16.1193 20.207 11.8409L19.3931 10.9591C15.2178 14.8132 8.78225 14.8132 4.607 10.9591L3.79307 11.8409Z",
    fill: "#232735"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFiles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "files.b1d4796771c48bba5ab601645d694ee4.svg";